// eslint-disable-next-line import/no-unassigned-import
import 'whatwg-fetch'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { getDefaultLogger } from './components/logger/logger'
import { store } from './store/store'
import { AppWithErrorBoundary } from './AppWithErrorBoundary'

const log = getDefaultLogger()

ReactDOM.render(
  <Provider store={store}>
    <AppWithErrorBoundary />
  </Provider>,
  document.getElementById('rle-wizard'),
  () => log.info('react component rendered on DOM')
)
